import type { MutableRefObject } from 'react';
import { useRef } from 'react';

/**
 * A React.Ref that keeps track of the passed value
 * https://www.npmjs.com/package/reakit-utils#useliveref
 *
 * @param value - Value to be saved in a ref
 * @returns Stable reference to the latest value
 */
export const useLiveRef = <T>(value: T): MutableRefObject<T> => {
  // Create a ref instance
  const ref = useRef(value);
  // On render get the latest value set in the ref
  ref.current = value;
  // Return the ref for stable reference
  return ref;
};
